export default __webpack_public_path__ + "static/media/graduate.575f2fec.svg";